<template>
<!--  2:37-->
  <div>
    <cancel-heading>Want to pause instead?</cancel-heading>

    <cancel-box class="my-50" label="If you cancel:">
      <cancel-feature-list/>
    </cancel-box>

    <cancel-content>If you're not certain you want to cancel your subscription or away from the business, we're now giving you the option to pause your account.</cancel-content>

    <cancel-content>Regardless of the reason, we're giving you the option to pause your account for 30, 60 or 90 days so you'll save money and avoid losing your data.</cancel-content>

    <cancel-content>Simply select how long you need to pause and we'll take care of the rest.</cancel-content>

    <div class="mt-100 flex flex-between">
      <button-outlined
        @click="pauseSubscription(30)"
      >Pause for 30 days</button-outlined>

      <button-outlined
        @click="pauseSubscription(60)"
      >Pause for 60 days</button-outlined>

      <button-outlined
        @click="pauseSubscription(90)"
      >Pause for 90 days</button-outlined>
    </div>
  </div>
</template>

<script>
import CancelBox from "./components/CancelBox.vue";
import CancelFeatureList from "./components/CancelFeatureList.vue";
import CancelHeading from "./components/CancelHeading.vue";
import CancelContent from "./components/CancelContent.vue";

export default {
  name: "PauseSubscription",
  components: {CancelContent, CancelHeading, CancelFeatureList, CancelBox},
  methods: {
    pauseSubscription(days) {
      this.$emit('pause', days)
    }
  },
}
</script>
